<template>    
    <v-btn id="liqButton" depressed small color="primary" @click="launchDialog()">
        Informe Liquidación
    </v-btn>     
</template>
<script>
export default {
    name: 'buttonLaunchReport',
    data () {
      return {        
      }
    },
    methods:{
        launchDialog(){
            this.dialog = true;
        }
    },
    computed:{    
        dialog: {
            get(){
                return this.$store.state.dialogInformeComerciales;
            },
            set(value){
                this.$store.state.dialogInformeComerciales = value;
            }
        }
    }    
}
</script>
<style scoped>
#liqButton{
    float: right;    
}
</style>